/**
 * @section 4.2.1.6
 */
import clsx from "clsx";
import React from "react";
import { makeThemedStyles } from "./../utils";
const useStylesForLanguageSwitchContainer = makeThemedStyles(
  "LanguageSwitchContainer",
  (theme) => ({
    LanguageSwitchContainer: {
      display: "flex",
    },
  })
);
type ElementProps = React.ComponentProps<
  React.HTMLFactory<HTMLElementTagNameMap["div"]>
>;
export const LanguageSwitchContainer: React.FunctionComponent<ElementProps> = (
  props: ElementProps
) => {
  const styles = useStylesForLanguageSwitchContainer();
  /* eslint-disable */

  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.LanguageSwitchContainer)}
    >
      {props?.children}
    </div>
  );
};
export default LanguageSwitchContainer;
